// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--4601d";
export var container = "styles-module--container--1ca22";
export var header = "styles-module--header--ddb2c";
export var metricSlider = "styles-module--metricSlider--39c6b";
export var slider = "styles-module--slider--d5d42";
export var sliderContainer = "styles-module--sliderContainer--80ce4";